// @ts-nocheck

import React, { useCallback, useMemo } from 'react';

import { SpecialFilterValues } from '../../constants/livebar';
import MatchRowsFiltersBar from '../MatchRowsFiltersBar';

const MatchRowsFilters = ({ setPreferences, facets, setScrollTop, prefs }) => {
  const onClickItemMobile = useCallback(
    (selectedSportId) => {
      if (prefs) {
        const { sportIds, wtvOnly } = prefs?.filters ?? {};

        if (selectedSportId === SpecialFilterValues.WINAMAX_TV_FILTER) {
          setPreferences({ ...prefs, filters: { sportIds, defaultValue: true, wtvOnly: !wtvOnly } });
        } else if (selectedSportId) {
          setPreferences({
            ...prefs,
            filters: {
              defaultValue: !!sportIds[selectedSportId],
              wtvOnly,
              sportIds: { ...sportIds, [selectedSportId]: !sportIds[selectedSportId] },
            },
          });
        }
        setScrollTop(true);
      }
    },
    [prefs, setPreferences, setScrollTop],
  );

  const selectedSportIds = useMemo(() => {
    const sportIds = [];

    if (!prefs) {
      return sportIds;
    }

    const { sportIds: filtersSportIds, wtvOnly } = prefs?.filters ?? {};

    if (filtersSportIds && Object.keys(filtersSportIds).length > 0) {
      Object.entries(filtersSportIds).forEach((entry) => {
        const [key, value] = entry;

        if (value) {
          sportIds.push(parseInt(key, 10));
        }
      });
    }
    if (wtvOnly) {
      sportIds.push(SpecialFilterValues.WINAMAX_TV_FILTER);
    }
    return sportIds;
  }, [prefs]);

  return <MatchRowsFiltersBar facets={facets} selectedSportIds={selectedSportIds} onClickItem={onClickItemMobile} />;
};

export default MatchRowsFilters;
